module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.$route.name.indexOf('orders') !== -1) ? _c('div', {
    staticClass: "is-pulled-right"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.printAll()
      }
    }
  }, [_vm._v("\n            Print All\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.$route.name.indexOf('orders') !== -1) ? _c('h1', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.company.name) + " Orders\n          "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.apiBusy
    },
    on: {
      "click": function($event) {
        return _vm.refreshAll()
      }
    }
  }, [_vm._v("\n            Check for New Orders\n          ")]), _vm._v(" "), _c('small', {
    staticStyle: {
      "font-size": "1.25rem"
    }
  }, [_vm._v("(last checked " + _vm._s(_vm.last_check) + ")")])]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'order') ? _c('h1', {
    staticClass: "title"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'orders'
      }
    }
  }, [_vm._v("Orders")]), _vm._v("\n          →\n          #" + _vm._s(_vm.currentOrder.id) + "\n          "), _c('button', {
    staticClass: "button is-primary is-pulled-right",
    on: {
      "click": function($event) {
        return _vm.printOrder()
      }
    }
  }, [_vm._v("Print Order")])], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.$route.name.indexOf('orders') !== -1) ? _c('div', {
    staticClass: "tabs"
  }, [_c('ul', [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'orders'
      },
      "exact": ""
    }
  }, [_c('a', [_c('span', {
    staticClass: "tag is-rounded is-danger"
  }, [_vm._v(_vm._s(_vm.newOrders.length))]), _vm._v("   New Orders")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'printed-orders'
      }
    }
  }, [_c('a', [_c('span', {
    staticClass: "tag is-rounded is-primary"
  }, [_vm._v(_vm._s(_vm.printedOrders.length))]), _vm._v("  \n            Printed Orders")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'archived-orders'
      }
    }
  }, [_c('a', [_c('span', {
    staticClass: "tag is-rounded is-success"
  }, [_vm._v(_vm._s(_vm.archivedOrders.length))]), _vm._v("  \n            Archived Orders")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'past-orders'
      }
    }
  }, [_c('a', [_c('span', {
    staticClass: "tag is-rounded is-success"
  }, [_vm._v(_vm._s(_vm.pastOrders.length))]), _vm._v("  \n            Last Year Orders")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'voided-orders'
      }
    }
  }, [_c('a', [_c('span', {
    staticClass: "tag is-rounded is-warning"
  }, [_vm._v(_vm._s(_vm.voidedOrders.length))]), _vm._v("   Voided Orders")])])], 1)]) : _vm._e(), _vm._v(" "), _c('router-view', {
    ref: "order_box"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c6aff48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/Orders.vue
// module id = 563
// module chunks = 0